import { sendPresenceHeartbeat } from '../../api/v1/auth/presence';

const HEARTBEAT_INTERVAL_MS = 45_000;

let activeTimer = null;
let currentToken = null;
let visibilityListenerAttached = false;

const beat = async (token) => {
  if (!token) return;
  if (typeof document !== 'undefined' && document.hidden) return;
  try {
    await sendPresenceHeartbeat(token);
  } catch {
    // Silent fail as per spec: do not block UI or spam notifications
  }
};

const startTimer = () => {
  if (activeTimer) clearInterval(activeTimer);
  activeTimer = setInterval(() => {
    if (currentToken && typeof document !== 'undefined' && !document.hidden) {
      void beat(currentToken);
    }
  }, HEARTBEAT_INTERVAL_MS);
};

const stopTimer = () => {
  if (activeTimer) {
    clearInterval(activeTimer);
    activeTimer = null;
  }
};

const onVisibilityChange = () => {
  if (typeof document === 'undefined') return;
  if (document.hidden) {
    stopTimer();
  } else if (currentToken) {
    // Fire immediately upon becoming visible, then resume cadence
    void beat(currentToken);
    startTimer();
  }
};

/**
 * Starts the presence heartbeat loop for an authenticated user.
 * Automatically pauses when tab is hidden, resumes on focus,
 * and clears on logout.
 *
 * @param {string} token - The access token
 */
export const startPresenceHeartbeat = (token) => {
  if (!token) {
    stopPresenceHeartbeat();
    return;
  }

  currentToken = token;

  if (!visibilityListenerAttached && typeof document !== 'undefined') {
    document.addEventListener('visibilitychange', onVisibilityChange);
    visibilityListenerAttached = true;
  }

  if (typeof document !== 'undefined' && !document.hidden) {
    void beat(token);
    startTimer();
  }
};

/**
 * Stops the presence heartbeat loop and clears timers/listeners.
 */
export const stopPresenceHeartbeat = () => {
  currentToken = null;
  stopTimer();
  if (visibilityListenerAttached && typeof document !== 'undefined') {
    document.removeEventListener('visibilitychange', onVisibilityChange);
    visibilityListenerAttached = false;
  }
};
